export const getItemAfterAsyncCall = (state, action) => {
    return action.payload.result;
};
export const getArrayAfterAsyncCall = (state, action) => {
    return action.payload.result;
};
export const deleteArrayItemAfterAsyncCall = (state, action) => {
    return state.filter(({ id }) => id !== action.payload.params);
};
export const updateArrayItemAfterAsyncCall = (state, action) => {
    return state.map((entity) => (entity.id === action.payload.result.id ? action.payload.result : entity));
};
export const createReducer = (initialState, handlers) => (state = initialState, actionC) => {
    if (Object.prototype.hasOwnProperty.call(handlers, actionC.type)) {
        return handlers[actionC.type](state, actionC);
    }
    return state;
};
//# sourceMappingURL=reducers.js.map